import Grid from '@mui/material/Grid';
import { ReactComponent as UpArrow } from '../../../assets/images/right_arrow.svg';
import { ReactComponent as DownArrow } from '../../../assets/images/down_arrow.svg';

const SectionHeader = ({ title, onClick, showSection, theme_mode, styles }) => {
    return (
        <Grid
            container
            item
            xs={12}
            sx={{
                background: theme_mode.bg,
                borderBottom: '1px solid #D9D9D9',
                marginTop: '2rem',
                marginLeft: '1rem',
                paddingLeft: '0.75rem !important',
                paddingBottom: '0.5rem !important',
                paddingTop: '0.75rem !important',
                borderRadius: '0.5rem',
                cursor: "pointer"
            }}
            onClick={onClick}
        >
            <Grid item xs={11} sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                <label style={{ ...styles.labelStyle, fontSize: '0.875rem' }} >{title}</label>
            </Grid>
            <Grid item xs={1} sx={{ textAlign: "right", paddingRight: '0.5rem !important' }}>
                {showSection ? <DownArrow width={24} height={24} /> :
                    <UpArrow width={24} height={24} />}
            </Grid>
        </Grid>)
}

export default SectionHeader;